// BM-H80 P2 — TokenGuard.
//
// Client-side gate for the tokenised routes. The server re-validates
// every fetch, so this guard is a UX shortcut: if the URL query has no
// ``token``, we render a friendly message instead of the form. When
// the token is present we render the child and let the child's first
// data fetch surface any server-side 401 as a hard failure.

import { AlertTriangle } from "lucide-react";

// eslint-disable-next-line react/prop-types
export default function TokenGuard({ token, children }) {
  if (!token) {
    return (
      <div
        data-testid="client-form-token-guard-missing"
        style={{
          maxWidth: 640,
          margin: "80px auto",
          padding: 24,
          fontFamily: "Georgia, serif",
          color: "#111",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            gap: 12,
            padding: 16,
            background: "#fff7ed",
            border: "1px solid #fdba74",
            borderRadius: 8,
          }}
        >
          <AlertTriangle size={20} color="#c2410c" style={{ marginTop: 2 }} />
          <div>
            <div style={{ fontWeight: 600, marginBottom: 6 }}>
              This link is missing its access token.
            </div>
            <div style={{ fontSize: 14, lineHeight: 1.5 }}>
              Please open the questionnaire using the link in your
              invitation email. If you have lost the email, contact
              your fee earner and they will resend the link.
            </div>
          </div>
        </div>
      </div>
    );
  }
  return children;
}
